// components/CustomerPrivateRoute.js
import React from 'react';
// import { Navigate } from 'react-router-dom';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './context/AuthContext';

import useCustomerAuthCheck from './hooks/useCustomerAuthCheck';
import LoginDialog from '../customer/LoginDialog';

const CustomerPrivateRoute = ({ children }) => {
  const { isCustomerAuthenticated } = useAuth();
  const { isTokenValid, showLoginDialog, setShowLoginDialog } =
    useCustomerAuthCheck();

  //   return isCustomerAuthenticated ? children : <Navigate to='/customer-login' />;
  // };
  const location = useLocation();

  if (!isCustomerAuthenticated || !isTokenValid) {
    if (showLoginDialog) {
      return (
        <>
          {children}
          <LoginDialog
            onClose={() => setShowLoginDialog(false)}
            onLogin={() => {}} // Handle login
          />
        </>
      );
    }
    return <Navigate to='/customer-login' state={{ from: location }} replace />;
  }

  // if (!isCustomerAuthenticated) {
  //   return (
  //     <Navigate
  //       to='/customer-login'
  //       state={{ from: location.pathname }}
  //       replace
  //     />
  //   );
  // }

  return children;
};

export default CustomerPrivateRoute;
